module.exports = __webpack_public_path__ + "media/promo/promo/images/round-arrows-87ed3819dbbdebf5fbdf893a3afe3892.svg";